'use strict';

var Log = require('utils/log');
var Misc = require('utils/misc');
var SVG = require('utils/svg');
var i18n = require('utils/i18n');

function GetElementIdentifier(element) {
    if (element && element.id) {
        return element.id;
    }
    return JSON.stringify(element);
}

function parseJSON(jsonString, element) {
    var result = {};
    if (jsonString === '' || jsonString === undefined) {
        Log.schema('WARNING: No context given for element: ' + GetElementIdentifier(element));
        return {};
    }
    try {
        result = JSON.parse(jsonString);
    } catch (e) {
        Log.schema(
            'WARNING: context of element: ' +
                GetElementIdentifier(element) +
                ' is no valid json. Returning raw string (' +
                jsonString +
                ')'
        );
        return jsonString;
    }
    return result;
}

function isValid(value) {
    return !isNaN(parseFloat(value)) || value === '--';
}

function formatValue(valueObject) {
    var isFixedUnit = valueObject && valueObject.is_unit_fixed;
    var valueUnit = Misc.getValueDisplayInfos(
        valueObject.rawValue,
        valueObject.type + '_' + valueObject.nr,
        valueObject.format,
        valueObject.unit,
        valueObject.display_unit,
        isFixedUnit
    );
    return (valueUnit.value || valueObject.rawValue) + ' ' + (valueUnit.unit || '');
}

function showFlow(context, color, on) {
    if (!context.flow_elements || !context.flow_elements[color]) {
        return;
    }

    _.each(context.flow_elements[color], function (elementID) {
        if ($('#' + elementID).length === 0) {
            Log.schema('toolkit_flow: element with id: "' + elementID + '" does not exist.');
            return;
        }
        $('#' + elementID + 'flow-background').remove();
        if (on) {
            var element = document.getElementById(elementID);
            var clone = $(element.cloneNode(true));
            clone.removeAttr('app-func');
            clone.removeAttr('app-context');
            clone.attr('id', elementID + 'flow-background');
            clone.attr('class', 'flow-' + color + '-background');
            $(element).after(clone);
            $(clone).attr('class', 'flow-' + color);
        } else {
            $('#' + elementID).removeClass('flow-' + color);
        }
    });
}

var SchemaFunctions = {
    flow: function (element, schemaContext, result) {
        if (result === undefined) {
            Log.schema('value not available for element: ' + GetElementIdentifier(element));
            return;
        }
        var context = parseJSON(this, element);
        var pumpIsOn = parseInt(result.rawValue);
        var oldClasses = $(element).attr('class') || '';
        if (pumpIsOn) {
            $(element).attr('class', 'pump-active ' + oldClasses);
        } else {
            $(element).attr('class', oldClasses.replace('pump-active', ''));
        }

        showFlow(context, 'cold', pumpIsOn);
        showFlow(context, 'hot', pumpIsOn);
    },

    value: function (element, schemaContext, istWert, sollWert) {
        function canBeFormatted(value) {
            return typeof value === 'object' && (value.has_format || value.displayValue != undefined);
        }

        $($(element).parents('g')[0]).removeAttr('display', 'none');

        var isConfigured = schemaContext.definedParameterList[schemaContext.isShowActualValue() ? 0 : 1];

        // is legacy element? -> skip this stuff
        if (!schemaContext.isLegacyFunction) {
            // "istWert" or "sollWert" was not supplied within the scheme -> hide the whole element
            // but only, if we are not in edit mode!
            SVG.removeClass($(element.parentNode.parentNode), ' invisible');
            if (!isConfigured && !schemaContext.isEditMode) {
                SVG.addClass($(element.parentNode.parentNode), ' invisible');
                return;
            }
        }

        var value = schemaContext.isShowActualValue() ? istWert : sollWert;
        if (value === undefined || value === '') {
            value = '--';
        }

        if (!canBeFormatted(value)) {
            element.textContent = [value.displayValue, value.rawValue, value, '--'].find(isValid);
            return;
        }
        if (isValid(value.value)) {
            element.textContent = value.value + ' ' + (value.unit || '');
            return;
        }
        element.textContent = value.displayValue || formatValue(value);
    },

    dynamicColor: function (element, schemaContext, result) {
        if (result === undefined) {
            Log.schema('value not available for element: ' + GetElementIdentifier(element));
            return;
        }
        var context = JSON.parse(this.context);
        // given a weight between 0 and 1, and two colors (min, max) as 3-element-arrays, returns the weighted color
        function getMeanColor(weight, min, max) {
            return [
                (1 - weight) * min[0] + weight * max[0],
                (1 - weight) * min[1] + weight * max[1],
                (1 - weight) * min[2] + weight * max[2],
            ];
        }
        var weight = Math.min(Math.max(result.rawValue, context.min), context.max - 1) / context.max;
        if (1 >= context.colors.length) {
            return;
        }
        var intervalWidth = 1 / (context.colors.length - 1);
        function getLowerColorBound(weight) {
            var segmentLength = 1 * intervalWidth;
            return Math.floor(weight / segmentLength);
        }
        var lowerBound = getLowerColorBound(weight);
        var minColor = context.colors[lowerBound];
        var maxColor = context.colors[lowerBound + 1];
        weight = weight / intervalWidth - lowerBound;

        var color = getMeanColor(weight, minColor, maxColor);
        element.setAttribute('fill', 'rgb(' + color.join(',') + ')');
    },

    time: function (element, schemaContext, result) {
        if (result === undefined) {
            Log.schema('value not available for element: ' + GetElementIdentifier(element));
            return;
        }
        var time = result.rawValue;
        var minutes = time % 100;
        var hours = (time - minutes) / 100;

        window.setInterval(function () {
            $('#seconds').attr('transform', 'rotate(' + moment().seconds() * 6 + ', 50,50)');
        }, 1000);

        $('#hours').attr('transform', 'rotate(' + (hours * 30 + minutes / 2) + ', 50,50)');
        $('#minutes').attr('transform', 'rotate(' + minutes * 6 + ', 50,50)');
    },

    color: function (element, schemaContext, value) {
        var context = parseJSON(this);
        var color = context[value.rawValue] || context.default || 'white';
        element.setAttribute('fill', color);
    },

    showHide: function (element, schemaContext, value) {
        if (value === undefined) {
            Log.schema('value not available for element: ' + GetElementIdentifier(element));
            return;
        }

        // context given: try parsing it into json
        var contextIsValid = true;
        try {
            var context = parseJSON(this);
            if ($.isEmptyObject(context)) {
                contextIsValid = false;
            }
        } catch (e) {
            // no or invalid context? -> assume standard case:
            // off => hide Element
            // on  => show Element
            Log.schema(
                'Warning: context of element: ' +
                    GetElementIdentifier(element) +
                    ' is no valid json or was omitted. It will be shown for Coil-value=1 and hidden otherwise'
            );
            contextIsValid = false;
        }
        if (!contextIsValid) {
            Misc.setVisible(element, value.rawValue == 1);
            return;
        }

        // legacy compability: map 'off', 'on' and 'auto' to '0', '1' and '2'
        context[0] = context[0] || context['off'];
        context[1] = context[1] || context['on'];
        context[2] = context[2] || context['auto'];
        delete context.off;
        delete context.on;
        delete context.auto;
        // hide all elements that are listed for the current value (if any)
        // and get elements to show
        var elementsToShow = undefined;
        _.each(context, function (domElementIDList, dataPointValue) {
            // make sure the elementlist is an array
            if (!Array.isArray(domElementIDList)) {
                domElementIDList = [domElementIDList];
            }
            if (dataPointValue == value.rawValue) {
                elementsToShow = domElementIDList;
            }
            _.each(domElementIDList, function (ID) {
                Misc.setVisible('#' + ID, false);
            });
        });
        // show all elements that are listed for the current value
        _.each(elementsToShow, function (ID) {
            Misc.setVisible('#' + ID, true);
        });
    },

    boiler: function toPercentage(element, schemaContext, value) {
        if (value === undefined) {
            Log.schema('value not available for element: ' + GetElementIdentifier(element));
            return;
        }
        if (!value.has_format) {
            value.max = 1000;
            value.min = 0;
            Log.schema(
                'toolkit_boiler: value has no format assuming min=' +
                    value.min +
                    ' and max=' +
                    value.max +
                    ' and using raw value.'
            );
        }
        // default config
        var config = {
            low: {
                color: 'red',
                treshold: 33,
            },
            half: {
                color: 'orange',
                treshold: 66,
            },
            full: {
                color: 'green',
            },
            max: value.max,
            min: value.min,
        };

        function toPercentage(value) {
            return Math.round((100 * (value - config.min)) / (config.max - config.min));
        }

        var context = parseJSON(this);
        // context given? -> overwrite defaults
        if (!$.isEmptyObject(context)) {
            if (context.colors) {
                config.low.color = context.colors.low || config.low.color;
                config.half.color = context.colors.half || config.half.color;
                config.full.color = context.colors.full || config.full.color;
            }
            if (context.tresholds) {
                config.low.treshold = context.tresholds.low || config.low.treshold;
                config.half.treshold = context.tresholds.half || config.half.treshold;
            }
            config.min = context.min || config.min;
            config.max = context.max || config.max;
            if (config.min > config.max) {
                min = config.max;
                config.max = config.min;
                config.min = min;
            }

            // invalid config, only show raw value
            if (config.max == config.min) {
                $(element).children('text').text = value.rawValue;
                Log.schema('invalid config (min=max) for element: ' + GetElementIdentifier(element));
                return;
            }
        }

        // Is the value in range?
        if (value.rawValue > config.max || config.min > value.rawValue) {
            Log.schema(
                'warning, value out of range! Value:' + value.rawValue + 'min: ' + config.min + 'max: ' + config.max
            );
            return;
        }

        var fillHeight = toPercentage(value.rawValue);
        $(element)
            .find('text')
            .text(fillHeight + '%');

        var $boilerFill = $(element).find('.rectangle-fill');
        $boilerFill.attr('fill', config.full.color);
        if (config.half.treshold >= fillHeight) {
            $boilerFill.attr('fill', config.half.color);
        }
        if (config.low.treshold >= fillHeight) {
            $boilerFill.attr('fill', config.low.color);
        }

        // fill boiler
        $boilerFill.attr('y', 100 - fillHeight);
    },

    // Assigns each register/coil-value a string
    // context:  map[value]string
    text: function (element, schemaContext, value) {
        if (element.tagName !== 'text') {
            Log.schema('Error: The function toolkit_text can only be applied to "text"-elements! Function is ignored');
            return;
        }
        var context = parseJSON(this);
        var text = context[value.rawValue] || context.default || '';
        element.textContent = text;
    },

    i18n: function (element, schemaContext, value) {
        element.textContent = i18n.TR(element.textContent);
    },

    goToTab: function (element, schemaContext, value) {
        var tab = parseInt(this);
        if (isNaN(tab)) {
            Log.schema(
                'Error: context of element: ' +
                    GetElementIdentifier(element) +
                    ' must be an integer + but was: "' +
                    this +
                    '".'
            );
            return;
        }
        $(element).on('click', function () {
            $('#js-schema-tabs #' + (tab + 1)).click();
        });
    },
};

function concatDigits(valueMap, startRegister, powers) {
    var value = 0;
    _.each(powers, function (power, index) {
        value += intTimesPower10(valueMap['MBR_' + (startRegister + index)], power);
    });
    return value;
}

// returns a number multiplied by 10^power to avoid results like 0.35000000000000000000017
function intTimesPower10(n, power) {
    return power >= 0 ? n * Math.pow(10, power) : n / Math.pow(10, -power);
}

function buildDefaultValue(valueMap, value, units) {
    value.rawValue = concatDigits(valueMap, value.nr, [4, 0, -3]);
    value.displayValue = value.rawValue + ' ' + (units[valueMap['MBR_' + (value.nr + 3)]] || '');
}

var RegisterFunctions = {
    durchfluss: function (valueMap, value) {
        buildDefaultValue(valueMap, value, ['m³/h', 'l/h']);
    },

    volumen: function (valueMap, value) {
        buildDefaultValue(valueMap, value, ['m³', 'l']);
    },

    leistung: function (valueMap, value) {
        buildDefaultValue(valueMap, value, ['kW', 'MW']);
    },

    arbeit: function (valueMap, value) {
        buildDefaultValue(valueMap, value, ['MWh', 'GJ']);
    },

    temperatur: function (valueMap, value) {
        value.rawValue = concatDigits(valueMap, value.nr, [0, -3]);
        value.displayValue = value.rawValue + ' °C';
    },
};

module.exports = {
    SchemaFunctions: SchemaFunctions,
    RegisterFunctions: RegisterFunctions,
    GetElementIdentifier: GetElementIdentifier,
};
